module.exports = require("commonmark");


//////////////////
// WEBPACK FOOTER
// external "commonmark"
// module id = 580
// module chunks = 0